import script from "./CampaignPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CampaignPage.vue?vue&type=script&setup=true&lang=ts"

import "./CampaignPage.vue?vue&type=style&index=0&id=5e78c5ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e78c5ca"]])

export default __exports__